import { theme } from '@revenuemarket/design';

import { IconProps } from '../../types/icon';
import { Svg } from '../style';

export default function ExpandLess({
  width = 24,
  height = 24,
  fill = theme.colors.grayscale400,
  ...props
}: IconProps) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.2902 8.70998L6.70021 13.3C6.31021 13.69 6.31021 14.32 6.70021 14.71C7.09021 15.1 7.72021 15.1 8.11021 14.71L12.0002 10.83L15.8802 14.71C16.2702 15.1 16.9002 15.1 17.2902 14.71C17.6802 14.32 17.6802 13.69 17.2902 13.3L12.7002 8.70998C12.3202 8.31998 11.6802 8.31998 11.2902 8.70998Z"
        fill={fill}
      />
    </Svg>
  );
}
